export default "__VITE_ASSET__CxJTLR_X__"